import { useMemo } from 'react';

import { selectors, useAppSelector } from 'state/global-state';
import { useServiceModeLive } from 'state/service-mode';

import { useNotificationCenterReadState } from './use-notification-center-read-state';
import { countUnreadNewsFeedCards } from './utils';

/**
 * Derives the unread News feed badge count, fully reactive (no slice scalar, no refresh action).
 * The read set and `isReady` come from useNotificationCenterReadState - the caller must not
 * render `count` while `isReady` is false, since it's only a best-effort guess until then.
 */
export const useUnreadNewsFeedCount = (): { count: number; isReady: boolean } => {
  const newsFeedContentCards = useAppSelector(selectors.loyalty.selectNewsFeedContentCards);
  const serviceMode = useServiceModeLive();
  const { isReady, readNotificationIds } = useNotificationCenterReadState();

  const count = useMemo(
    () => countUnreadNewsFeedCards(newsFeedContentCards, readNotificationIds, serviceMode),
    [newsFeedContentCards, readNotificationIds, serviceMode]
  );

  return { count, isReady };
};
